export const urls = {
  developmentUrl: 'https://dev.bookings.olpejetaconservancy.org'
}
